import axios from "axios";
import {config} from "../constants";
import authHeader from "./auth-header";
import CommonService from "./common.service";

class ContactService {

    send(subject, contactMessage) {
        return axios.post(
            config.API_URL + "app-send-message",
            {
                subject: subject,
                message: contactMessage,
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

}

export default new ContactService();
